import type { FaireProductEntity } from "../../entity_types/product";

export const p_gt8crrbsqr: FaireProductEntity = {
  token: "p_gt8crrbsqr",
  type: "product",
  name: "Ginger & Cayenne Grass-fed Beef Bone Broth 14oz",
  brandToken: "b_3nwax652hv",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/b20b12541c6ecebdb043c939e6524691c9a141bc0f37a9f649988ccff3985b2c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/01efcd2ea042cd45f3e5782ee4a4ec48a5b2275a992602a6c2498b7563a9c3d2.png",
  ],
  priceDollars: 8.31,
  description:
    'Burn, baby, burn! When a customer asked our founder, Alysa, to make her a bone broth that would help with weight loss, she knew it needed to be more than functional. She wanted this customer to enjoy making this decision for herself every morning! With ginger and cayenne pepper, this bone broth tonic intentionally turns up the heat to unleash metabolic benefits.\n\nA note on our sourcing: we only use grass-fed and finished beef bones and organic herbs and veggies - no hormones, GMOs, added sugar, antibiotics or preservatives. From brew to jar, we also utilize a 100% plastic-free process, and all of our broths are shelf-stable!\n\nSold in packs of 4 - trust us, you’ll go through it faster than you think!\n\n"I’ve tried them all, and this is my favorite. I like the hint of heat from the pepper and ginger, making this flavor a ‘stand out’ from other flavors. The flavor profile is familiar, comforting and layered unlike so many bone broths that taste a lot like water." -Julie M.',
  tags: [],
  msrpDollars: 16.61,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:45.460Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
